export default __webpack_public_path__ + "static/media/potilasohjeet-darkblue.2f526fc8.svg";